module.exports = __webpack_public_path__ + "static/media/HTW.cf265455.jpg";